import { defineComponent } from "vue";

export default defineComponent({
  template: `
      <div
          v-if="isVisible"
          class="alert alert-dismissible"
          :class="{
              'alert-success': type === 'success',
              'alert-danger': type === 'error',
              'alert-info': type === 'info',
            }"
          role="alert"
      >
      <slot></slot>
      <button
          v-if="this.closable"
          @click="hideAlert"
          type="button"
          class="btn-close"
          aria-label="Close"
      ></button>
      </div>
    `,
  name: "MessageAlert",
  props: ["type", "closable"],
  data() {
    return {
      isVisible: true,
    };
  },
  methods: {
    async hideAlert() {
      this.isVisible = false;
    },
  },
});
